import { formatTime } from '../utils';

export default function getBaseDisplayLabel(dtstart, dtend, usTimeFormat) {
  return `${formatTime(dtstart, usTimeFormat)} - ${formatTime(dtend, usTimeFormat)}`;
}
